import { render, staticRenderFns } from "./GiftsetOrderPage.vue?vue&type=template&id=0019778e&"
import script from "./GiftsetOrderPage.vue?vue&type=script&lang=js&"
export * from "./GiftsetOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports